import { CapoPlugin } from "/home/stcomuser/htdocs/satyatunes.com/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];